import mixpanel from 'mixpanel-browser';

export function useHomeAnalytics() {
  function trackTileClick(tileName: string, position: number): void {
    try {
      mixpanel.track('home_card_clicked', {
        card_name: tileName,
        card_position: position,
      });
    } catch (_e) {
      // silent
    }
  }
  return { trackTileClick };
}
